import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";
import { InviteMemberButtonComponent } from "./invite-member-button.component";

@NgModule({
  declarations: [InviteMemberButtonComponent],
  imports: [CommonModule, MatDialogModule, TranslateModule, LucideAngularModule],
  exports: [InviteMemberButtonComponent],
})
export class InviteMemberButtonModule {}
